(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function formatMsg(el, text, isError) {
    if (!el) return;
    el.textContent = text || '';
    el.dataset.state = isError ? 'error' : 'ok';
  }

  function setDisabled(el, disabled) {
    if (!el) return;
    el.disabled = !!disabled;
    el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function formatNumber(n) {
    return Number(n || 0).toLocaleString('ja-JP');
  }

  function getSDK() {
    if (!window.VipApp || !window.VipApp.VIPAppSDK) return null;
    return new window.VipApp.VIPAppSDK(
      window.__vipOrigin || window.location.origin
    );
  }

  async function initOne(root) {
    if (!root || root.dataset.vipInited === '1') return;
    root.dataset.vipInited = '1';

    const availableEl = qs(root, '[data-vip-available]');
    const pendingEl   = qs(root, '[data-vip-pending]');
    const inputEl     = qs(root, '[data-vip-input]');
    const issueBtn    = qs(root, '[data-vip-issue]');
    const cancelBtn   = qs(root, '[data-vip-cancel]');
    const msgEl       = qs(root, '[data-vip-msg]');

    if (!inputEl || !issueBtn) return;

    const sdk = getSDK();

    try {
      console.log('[VIP][init] sdk:', sdk);
      console.log('[VIP][init] origin:', window.__vipOrigin, window.location.origin);
    } catch (e) {}

    if (!sdk) {
      formatMsg(msgEl, 'VIP SDKの読み込み中です…', false);
      setTimeout(() => {
        root.dataset.vipInited = '0';
        scan();
      }, 200);
      return;
    }

    /** 状態 */
    let lastDiscountCode = null;
    let pendingPoint = 0;

    /** UI同期 */
    function syncUI() {
      // 解除ボタン（将来用）
      setDisabled(cancelBtn, !lastDiscountCode);

      // 利用予定ポイント表示
      if (pendingEl) {
        if (pendingPoint > 0) {
          pendingEl.style.display = '';
          pendingEl.textContent = `利用予定 ${formatNumber(pendingPoint)} pt`;
        } else {
          pendingEl.style.display = 'none';
          pendingEl.textContent = '';
        }
      }
    }

    /** 利用可能ポイント取得 */
    try {
      const { approvedPoint } = await sdk.customerApprovedPoint();
      console.log('[VIP][approvedPoint] result:', approvedPoint);

      if (availableEl) {
        availableEl.textContent = String(approvedPoint ?? 0);
      }
      formatMsg(msgEl, '', false);
    } catch (e) {
      console.log('[VIP][approvedPoint] error:', e);
      formatMsg(msgEl, 'ポイント情報を取得できませんでした。', true);
    }

    /** 適用 */
    issueBtn.addEventListener('click', async () => {
      const raw = (inputEl.value || '').trim();
      const point = Number(raw);

      if (!Number.isFinite(point) || point <= 0) {
        formatMsg(msgEl, '利用するポイント数を入力してください。', true);
        return;
      }

      setDisabled(issueBtn, true);
      setDisabled(cancelBtn, true);
      formatMsg(msgEl, '割引コードを発行しています…', false);

      try {
        const res = await sdk.customerPointUse({ point });
        console.log('[VIP][pointUse] response:', res);

        lastDiscountCode = res?.discountCode || null;
        pendingPoint = lastDiscountCode ? point : 0;

        console.log('[VIP][pointUse] discountCode:', lastDiscountCode);

        if (lastDiscountCode) {
          formatMsg(
            msgEl,
            `割引コードを発行しました：${lastDiscountCode}`,
            false
          );
          window.location.reload();
        } else {
          formatMsg(msgEl, '割引コードが取得できませんでした。', true);
        }

        syncUI();
      } catch (e) {
        console.log('[VIP][pointUse] error:', e);
        lastDiscountCode = null;
        pendingPoint = 0;
        formatMsg(msgEl, '割引コードの発行に失敗しました。', true);
        syncUI();
      } finally {
        setDisabled(issueBtn, false);
      }
    });

    /** 解除（将来用：今はUIが無くてもOK） */
    if (cancelBtn) {
      setDisabled(cancelBtn, true);

      cancelBtn.addEventListener('click', async () => {
        if (!lastDiscountCode) return;

        setDisabled(cancelBtn, true);
        setDisabled(issueBtn, true);
        formatMsg(msgEl, '解除しています…', false);

        try {
          const res = await sdk.customerPointCancel();
          console.log('[VIP][pointCancel] response:', res);

          lastDiscountCode = null;
          pendingPoint = 0;

          formatMsg(msgEl, '解除しました。', false);
          syncUI();
        } catch (e) {
          console.log('[VIP][pointCancel] error:', e);
          formatMsg(msgEl, '解除に失敗しました。', true);
          syncUI();
        } finally {
          setDisabled(issueBtn, false);
        }
      });
    }

    /** 初期同期 */
    syncUI();
  }

  function scan() {
    document
      .querySelectorAll('[data-vip-point-use]')
      .forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
